export default {
  large: 1024,
  medium: 768,
  small: 639,
};
